import axios from 'axios';

export default axios.create({
  baseURL: `https://publica.cnpj.ws/cnpj/`,
  // responseType: "json"
});
